import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";

//components
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { DataTableCard } from "./styled";

//utils
import { FaFilePdf, FaReceipt } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import { formatDate, formatReal } from "../../../../../helpers";

export function WithdrawalTable(props: any) {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const {
		nodes,
		treeFields,
		sortField,
		sortOrder,
		handleTableSort,
		handleShowInvoice,
		handleShowVoucher,
	} = props;

	function accountTemplate(node: any) {
		if (node.account_bank) {
			return (
				<Row>
					<p className="mb-1">
						<b>{translation("manager.withdrawal.bank")}:</b>{" "}
						{node.account_bank.bank_number} -{" "}
						{node.account_bank.bank}
					</p>
					<p className="mb-1">
						<b>{translation("manager.withdrawal.agency")}:</b>{" "}
						{node.account_bank.agency} &nbsp;
						<b>{translation("manager.withdrawal.account")}:</b>{" "}
						{node.account_bank.account} &nbsp;
						<b>
							{translation("manager.withdrawal.accountType")}:
						</b>{" "}
						{node.account_bank.type}
					</p>
				</Row>
			);
		} else {
			return "Não possui conta cadastrada";
		}
	}

	function dateTemplate(node: any) {
		return <span>{formatDate(node.request_date)}</span>;
	}

	function finishDateTemplate(node: any) {
		if (node.completion_date) {
			return <span>{formatDate(node.completion_date)}</span>;
		}
		return (
			<span className="text-dark-grey">
				{translation("manager.withdrawal.openRequest")}
			</span>
		);
	}

	function valueTemplate(node: any) {
		return <span>R$ {formatReal(node.value.toFixed(2))}</span>;
	}

	function actionsTemplate(node: any) {
		return (
			<div className="d-flex justify-content-around">
				<OverlayTrigger
					placement="top"
					overlay={
						<Tooltip>
							{translation("manager.withdrawal.viewInvoice")}
						</Tooltip>
					}
				>
					<span
						className="icon-withdrawal text-blueberry"
						onClick={() => handleShowInvoice(node)}
					>
						<FaFilePdf />
					</span>
				</OverlayTrigger>
				<OverlayTrigger
					placement="top"
					overlay={
						<Tooltip>
							{node.status === 1
								? translation(
										"manager.withdrawal.unavailableVoucher",
									)
								: translation("manager.withdrawal.viewVoucher")}
						</Tooltip>
					}
				>
					<span
						className={
							node.status === 1
								? "icon-disabled"
								: "icon-withdrawal text-blueberry"
						}
						onClick={() =>
							node.status === 2 && handleShowVoucher(node)
						}
					>
						<FaReceipt />
					</span>
				</OverlayTrigger>
			</div>
		);
	}

	function rowClassName(node: any) {
		return {
			"p-opened": node.status === 1,
			"p-finished": node.status === 2,
		};
	}

	function statusTemplate(node: any) {
		return (
			<OverlayTrigger
				placement="top"
				overlay={
					<Tooltip>{translation("manager.requests.details")}</Tooltip>
				}
			>
				<Link to={`/manager/admin/request/${node.id}`}>
					<span className="icon-withdrawal text-blueberry">
						<MdOutlineOpenInNew />
					</span>
				</Link>
			</OverlayTrigger>
		);
	}

	return (
		<div>
			<DataTableCard>
				<DataTable
					value={nodes}
					rowClassName={rowClassName}
					sortField={sortField}
					sortOrder={sortOrder}
					onSort={(e) => handleTableSort(e)}
					responsiveLayout="scroll"
				>
					{!!treeFields?.length &&
						treeFields?.map((col: any) => {
							if (col.accountTemplate) {
								return (
									<Column
										key={col.field}
										body={accountTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.actionsTemplate) {
								return (
									<Column
										key={col.field}
										body={actionsTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.dateTemplate) {
								return (
									<Column
										key={col.field}
										body={dateTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.valueTemplate) {
								return (
									<Column
										key={col.field}
										body={valueTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.finishDateTemplate) {
								return (
									<Column
										key={col.field}
										body={finishDateTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else if (col.statusTemplate) {
								return (
									<Column
										key={col.field}
										body={statusTemplate}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							} else {
								return (
									<Column
										key={col.field}
										field={col.field}
										header={col.header}
										style={col.style}
										{...col}
									/>
								);
							}
						})}
					{props.children}
				</DataTable>
			</DataTableCard>
		</div>
	);
}
